import { useTranslation } from 'react-i18next';
import { Avatar, AvatarFallback, AvatarImage, Button } from '@sib/ui';
import {
  getInitials,
  extractNameFromEmail,
  removeCompanyFromName,
} from '@sib/utils';
import { Invitee } from '@spendbrain/types/user';

interface InviteesListItemProps {
  data: Invitee;
  onRemove: () => void;
}

export const InviteesListItem = ({ data, onRemove }: InviteesListItemProps) => {
  const { t } = useTranslation();

  const userName =
    removeCompanyFromName(data.name) || extractNameFromEmail(data.email);

  return (
    <li className="border-border flex items-center justify-between border-b px-3.5 py-2 last:border-none">
      <div className="flex items-center gap-6">
        <Avatar className="size-[44px] bg-white">
          <AvatarImage src={data.imageUrl} />
          <AvatarFallback className="bg-muted">
            {getInitials(userName)}
          </AvatarFallback>
        </Avatar>
        <div className="flex flex-col">
          <p className="text-sm leading-5 font-semibold">{userName}</p>
          <p className="text-sm leading-5">{data.email}</p>
        </div>
      </div>
      <Button onClick={onRemove} variant="outline" className="lowercase">
        {t('components.shareDialog.remove')}
      </Button>
    </li>
  );
};
